// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
// Selectirs
import {selectSourceCredibilityQueryResult, selectSourceCredibilityPageLoading, selectSourceCredibilityShowInitWaitingMessage} from '../_selectors/source-credibility.selectors';

export class SourceCredibilityDataSource extends BaseDataSource {
    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectSourceCredibilityPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectSourceCredibilityShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectSourceCredibilityQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
